import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Alerts, SEO, Text, Themes } from './components';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'

import Model from './pages/app/app-model'; 
import OwnerModel from './pages/owner/owner-model';  
import UserModel from './pages/user/user-model';
import BaseView from './pages/base/base-view.component'; 
import AppRoutes from './pages/app/app-routes.component';
import ApiService from './services/api.service';
import AppService from './services/app.service';

interface IProps { 
}

interface IState {
  datarow: Model;
  errors: any;
}

export default class App extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
        datarow: Model.defaultValue(),
        errors: null,
    }
  }

  private onLoad = (data:any) => {    
    this.setState({datarow:  data});
    OwnerModel.setOwner(data?.owner, data?.ownerCaption);
    document.title = data?.name;
    document.querySelector('meta[name="og:image"]')?.setAttribute('content', window.location.origin+ '/assets/thumbnail.png');
    if (!UserModel.isSignin()) UserModel.removeUser();
  }

  private onError = (data: any) => {
    this.setState({errors: data});
    if (data && !data?.[0]?.includes('Server')) UserModel.removeUser();
  }

  render() {
    return (
      <>
        <BaseView id={+AppService.appId()}
          model={Model} onLoad={this.onLoad} onError={this.onError}/>

        {this.state.errors?.[0] &&  <Text label={this.state.errors[0] + '. Please reload in a moment.'} color='red' icon='gpp_bad' iconSize={AppService.isMobile()? 'extralarge' : 'medium'} sx={{padding: 5}}/> }

        {(this.state.datarow.id > 0 || !ApiService.apiUrl) &&
          <Themes theme={this.state.datarow.theme}>
            <SEO description={this.state.datarow.description} />
            <Alerts>
              <BrowserRouter>
                <Switch>   
                  <Route path='*' render={(params) => <AppRoutes {...params} />} />
                </Switch>
              </BrowserRouter>
            </Alerts>
          </Themes>
        }
        
      </>
    );
  }
}